import { HStack } from '@pets-ui/HStack/HStack'
import { ArrowRightLarge } from '@pets-ui/Icons'
import { Text } from '@pets-ui/Text/Text'
import { colors } from '@pets-ui/tokens/colors.stylex'
import { VStack } from '@pets-ui/VStack/VStack'

const CARD_WIDTH = 172
const CARD_HEIGHT = 172

interface NavigateToBrandCardProps {
  onClick: () => void
}

/** TODO: 待設計完成設計稿，再仔細修正外觀 */
export const NavigateToBrandCard = (props: NavigateToBrandCardProps) => {
  const { onClick } = props

  return (
    <VStack
      width={CARD_WIDTH}
      height={CARD_HEIGHT}
      backgroundColor={colors.white}
      borderWidth={1}
      borderStyle="solid"
      borderColor={colors.grey200}
      borderRadius={4}
      flexShrink={0}
      alignItems="center"
      justifyContent="center"
      gap={2}
      cursor="pointer"
      onClick={onClick}
    >
      <HStack
        width={48}
        height={48}
        borderRadius={48}
        backgroundColor={colors.grey100}
        alignItems="center"
        justifyContent="center"
      >
        <ArrowRightLarge color={colors.grey700} fontSize={24} />
      </HStack>
      <Text color={colors.grey700}>前往品牌館</Text>
    </VStack>
  )
}
